export namespace TealiumActionTypes {
  export const EmailQuote = '[Tealium] Email Quote';
  export const InitTealium = '[Tealium] Init';
}
